import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  age: [],
  brandCodes: [],
  categoryCodes: [],
  classCodes: [],
  cocCatalogs: [],
  cocSubCategory: [],
  commitmentActive: null,
  commitmentExpired: null,
  commitmentLevel: null,
  commitmentName: null,
  commitmentNumber: null,
  commitmentStatus: null,
  commitmentType: null,
  coos: [],
  deactivatedAdSampleTypes: [],
  deactivatedPurposes: [],
  departmentCodes: [],
  devSearchParamsCache: null,
  distros: [],
  divisionCodes: [],
  fabricDesc: null,
  fabricType: null,
  flowLongDescriptions: [],
  gender: [],
  gisAgents: [],
  inStoreDates: [],
  itemTypes: [],
  linePlans: [],
  marketCodes: [],
  materialAction: [],
  millCode: null,
  mouStatus: null,
  multiDivisionCodes: null,
  noFilterPurposes: null,
  planningPeriods: [],
  planningYears: [],
  plmSampleTypes: [],
  productTeam: [],
  productTypes: [],
  purposes: [],
  rawMaterialType: [],
  rdNumber: null,
  requestPurpose: [],
  roundNum: [],
  sampleMarkets: [],
  seasonalWorkspace: [],
  shipToAttns: [],
  singleGisAgents: null,
  singlePurposes: null,
  sizeModels: [],
  smrSearchParamsCache: null,
  smrStatus: [],
  ssns: [],
  subCategoryCodes: [],
  subClassCodes: [],
  toBeApprovedBy: null,
  utilizationActive: null,
  utilizationCreatedBy: null,
  utilizationCreatedDateFrom: null,
  utilizationCreatedDateTo: null,
  utilizationLastModifiedBy: null,
  utilizationLastModifiedDateFrom: null,
  utilizationLastModifiedDateTo: null,
  utilizationStatus: null,
  utilizationToBeApprovedBy: null,
  flowNames: null,
  orderingTimelinesss: null,
  smsSearchCriteria: {
    purposes: null,
    singlePurposes: null,
    noFilterPurposes: null,
    sizeModels: null,
    planningPeriods: null,
    planningYears: null,
    classCodes: null,
    subClassCodes: null,
    flowLongDescriptions: null,
    flowNames: null,
    orderingTimelinesss: null,
    ssns: null,
    distros: null,
    gisAgents: null,
    coos: null,
    inStoreDates: null,
    brandCodes: null,
    divisionCodes: null,
    departmentCodes: null,
    categoryCodes: null,
    subCategoryCodes: null,
    linePlans: null,
    deactivatedPurposes: null,
    deactivatedAdSampleTypes: null,
    sampleMarkets: null,
    masterStyleNumber: null,
    multiDivisionCodes: null,
    commitmentActive: null,
    commitmentExpired: null,
    commitmentLevel: null,
    commitmentName: null,
    commitmentNumber: null,
    commitmentStatus: null,
    commitmentType: null,
    fabricDesc: null,
    fabricType: null,
    millCode: null,
    mouStatus: null,
    rdNumber: null,
    singleGisAgents: null,
    toBeApprovedBy: null,
    utilizationActive: null,
    utilizationCreatedBy: null,
    utilizationCreatedDateFrom: null,
    utilizationCreatedDateTo: null,
    utilizationLastModifiedBy: null,
    utilizationLastModifiedDateFrom: null,
    utilizationLastModifiedDateTo: null,
    utilizationStatus: null,
    utilizationToBeApprovedBy: null,
    marketCodes: null,
    roundNum: null,
    cocSubCategory: null,
    age: null,
    gender: null,
    catalog: null,
    isCommented: null,
    likeHoldDrop: null,
    roundNumber: null,
    vendorRefNum: null,
    courier: null,
    smrOrderingTimeliness: null,
    smrYardageTimeliness: null
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/samplemanagement/common/store/index.js